/* eslint-disable quote-props, key-spacing */
export default {
  api: '/api/v1/',

  'api:post:exam-start': '/api/v1/exams/:examId/start/',
  'api:post:exam-submit': '/api/v1/exams/:examId/submit/',
  'api:get:exam-sitting': '/api/v1/exams/:examId/sitting/',
  'api:get:exam-mistakes': '/api/v1/exams/:examId/mistakes/',

  'api:get:exam-detail': '/api/v1/exams/:examId/',
  'api:get:exam-detail:cached': '/api/v1/exams-cached/:examId/',
  'api:get:exam-detail:demo': '/api/v1/demo-exams-cached/:examId/',

  'api:get:exam-detail-solution': '/api/v1/exams/:examId/solution/',
  'api:get:class-exam-question-responses':
    '/api/v1/classes/:classId/exam/:examId/responses/:questionId/',
  'api:get:exam-questions': '/api/v1/exam-questions/:questionId/',
  'api:get:exam-responses': '/api/v1/exam-responses/:responseId/',
  'api:patch:exam-response-grok': '/api/v1/exam-responses/:responseId/grok/',
  'api:patch:exam-response-mark': '/api/v1/exam-responses/:responseId/mark/',
  'api:patch:exam-response-checklist-reflections':
    '/api/v1/exam-responses/:responseId/checklist-reflections/',
  'api:post:exam-questions-feedback':
    '/api/v1/exam-questions/:questionId/feedback/',
  'api:post:exam-questions-note': '/api/v1/exam-questions/:questionId/note/',
  'api:exam-question-update': '/api/v1/exam-question-update/:questionId/',
  'api:exam-section-category-list': '/api/v1/exam-section-categories/',
  'api:exam-section-category-detail':
    '/api/v1/exam-section-categories/:categoryId/',
  'api:exam-section-detail': '/api/v1/exam-sections/:examSectionId/',
  'api:post:exam-question-respond':
    '/api/v1/exam-questions/:questionId/respond/',
  'api:post:exam-question-respond:demo':
    '/api/v1/demo/exam-questions/:questionId/respond/',
  'api:post:exam-question-grok': '/api/v1/exam-questions/:questionId/grok/',
  'api:post:exam-question-mark': '/api/v1/exam-questions/:questionId/mark/',
  'api:post:exam-question-checklist-reflection':
    '/api/v1/exam-questions/:questionId/checklist-reflection/',
  'api:delete:exam-sitting-responses': '/api/v1/exams/:examId/responses/',
  'api:get:exam-attachments': '/api/v1/exams/:examId/attachments/',

  'api:student-course-progress':
    '/api/v1/classes/:classId/students/:profileId/progress/',
  'api:student-lesson-progress':
    '/api/v1/classes/:class_id/students/:student_id/lesson_progress/:lesson_id/',
  'api:your-classes': '/api/v1/your-classes/',
  'api:privileged-content': '/api/v1/classes/:classId/privileged-content/',
  'api:class-list-topic-progress-summary':
    '/api/v1/classes/topic_progress_summary/?year=:year',
  'api:class-topic-progress-detail': '/api/v1/classes/:classId/topic/:topicId/',
  'api:class-exam-sitting':
    '/api/v1/classes/:classId/exam/:examId/sittings/:sittingId/',
  'api:class-exam-sitting-list': '/api/v1/classes/:classId/exam/:examId/',
  'api:get:class-exam-question-set-aggregates':
    '/api/v1/classes/:classId/exam/:examId/lesson-question-aggregates/',
  'api:get:question-set-csv-export':
    '/api/v1/classes/:classId/exam/:examId/csv/',

  // TBC: not used anymore it seems? remove?
  'api:topic_progress-detail': '/api/v1/topic_progress/:topicId/',

  // TBC: confirm this is still being used. if not used anymore, remove?
  'api:course_summary_by_class_id':
    '/api/v1/course_summary_by_class_id/:classId/',

  'api:user-progress-course':
    '/api/v1/user/:userId/course-progress-by-class-id/:classId/',

  'api:attachment-list': '/api/v1/attachments/',
  'api:attachment-detail': '/api/v1/attachments/:attachmentId/',
  'api:class-exam-sittings': '/api/v1/classes/:classId/exam/:examId/',
  'api:class-detail': '/api/v1/classes/:classId/',
  'api:class-course-progress': '/api/v1/classes/:classId/course-progress/',
  'api:class-lesson-progress':
    '/api/v1/classes/:classId/lesson-progress/:lessonId/',
  'api:class-attachments':
    '/api/v1/classes/:classId/attachments/:attachmentType/:objectId/',
  'api:demo-attachments': '/api/v1/demo/attachments/:attachmentType/:objectId/',
  'api:watermark-course-attachments':
    '/api/v1/classes/:classId/attachments/watermark_course_attachments/',

  'api:class-teacher-notes-list': '/api/v1/lessons/:lessonId/notes/',
  'api:class-teacher-notes-detail': '/api/v1/lessons/:lessonId/notes/:noteId/',

  'api:class:classmates': '/api/v1/classes/:classId/classmates/',

  'api:post:class-resource-lock':
    '/api/v1/classes/:classId/resources/:resourceId/lock/',
  'api:class-exam-lock': '/api/v1/classes/:classId/exam/:examId/lock/',

  'api:job': '/api/v1/job/',
  'api:course-list': '/api/v1/courses/',
  'api:library-courses': '/api/v1/library-courses/',
  'api:course-detail': '/api/v1/courses/:courseId/',
  'api:course-progress-list': '/api/v1/course_progress/',
  'api:application-lesson-detail': '/api/v1/lessons/:lessonId/',
  'api:admin-lesson-detail': '/api/v1/admin-lessons/:lessonId/',
  'api:demo-lesson-detail': '/api/v1/demo-lessons/:lessonId/',
  'api:lesson-chunk-visits': '/api/v1/lessons/:lessonId/progress/', // ChunkVisits
  'api:chunk-visit': '/api/v1/chunks/:id/visit/',
  'api:lesson-responses-detail': '/api/v1/lessons/:lessonId/responses/', // QuestionAttempts

  'api:branch-for-select': '/api/v1/branch/for_select/',
  'api:branch-for-select-courses': '/api/v1/branch/for_select_courses/',
  'api:class-bookmarks': '/api/v1/bookmarks/user/:userId/class/:classId/',
  'api:bookmark': '/api/v1/bookmark/:id/',
  'api:lesson-quiz-stats': '/api/v1/lessons/:id/question_stats/',
  'api:course-teacher-stats': '/api/v1/courses/teacher_stats/',
  'api:post:short-link': '/s/link/',

  'ajax:evaluate-answer': '/ajax/evaluate-answer/',
  'ajax:bookmark': '/bookmarks/ajax_form/',
  'ajax:self-assessment': '/ajax/self-assessment/',
  // Classes
  'api:school-class-list': '/api/v1/schools/:id/classes/',

  // Schools
  'api:get:school-activation-report':
    '/api/v1/schools/reports/activation/:schoolId/:calendarYear/',
  'api:get-all-schools': '/api/v1/schools/',

  // Users
  'api:user': '/api/v1/user/:userId/', // TODO: remove one of these..
  'api:users': '/api/v1/user/:id/',
  'api:users-save-role': '/api/v1/user/:id/save_role/',
  'api:users-get-roles': '/api/v1/user/:id/get_roles/',

  // Roles
  'api:roles': '/api/v1/roles/',

  // Enrolments
  'api:enrolments': '/api/v1/enrolments/',

  // Syllabus
  'api:knowledge-unit-detail': '/api/v1/knowledge_units/:id/',
  'api:syllabus-skills': '/api/v1/syllabuses/:id/skills/',
  'api:skills': '/api/v1/syllabuses/skills/',

  // payments
  'api:ledger-payment': '/api/v1/payment/process/',
  'api:ledger-payment-by-code': '/api/v1/payment/process/:paymentLinkCode/',
  'api:payment-fetch-ledger': '/api/v1/payment/ledger/',
  'api:payment-fetch-ledger-by-payment-link-code':
    '/api/v1/payment/ledger/:paymentLinkCode/',
  'api:payments-students-owing':
    '/api/v1/payment/report/owing_student_payments/:schoolId/:calendarYear/',
  'api:payments-students-owing-csv':
    '/api/v1/payment/report/owing_student_payments/:schoolId/:calendarYear/?filetype=csv',
  'api:payments-refunds-owed:generate':
    '/api/v1/payment/report/edrolo_owing_payments/generate/:calendarYear/',
  'api:payments-refunds-owed:fetch':
    '/api/v1/payment/report/edrolo_owing_payments/fetch/:taskId/',
  'api:payments-refunds-owed:fetch-csv':
    '/api/v1/payment/report/edrolo_owing_payments/fetch/:taskId/?filetype=csv',
  'api:payments-refunds-processes': '/api/v1/payment/refunds/:calendarYear/',
  'api:payments-refunds-initiate': '/api/v1/payment/refunds/',
  'api:payments-schools': '/api/v1/payment/schools/:calendarYear/',

  // 2021 Payments
  'api:payments-checkout-data': '/api/v1/payment/checkout/',
  'api:payments-purchase': '/api/v1/payment/purchase/',

  // study planner v2
  'api:course-assemblage': '/api/v1/presitree/class/:classId/assemblage/',

  // Used by caption ordering content-tools
  'api:course-collection': '/api/v1/presitree/:courseId/assemblage/',

  // sales leads
  'api:sales-leads-report-csv': '/sales-lead/report/csv/',

  // profile
  'api:set-profile-key-store-item': '/api/v1/profile/keystore/',
  'api:teacher-trial': '/api/v1/user-trials/teacher/',
  'api:welcome-journey-emails': '/api/v1/welcome-journey/emails/',

  // fulfilment
  'api:fulfilment': '/fulfilment/profile/',
  'api:fulfilment-by-payment-link-code':
    '/fulfilment/profile-by-payment-link-code/:paymentLinkCode/',

  'api:caption-orders-lesson': '/captions/lesson-orders/:lessonId/',
  'api:caption-orders-exam': '/captions/exam-orders/:examId/',
  'api:captions:create-orders': '/captions/orders/',
  'api:captions:review-orders': '/captions/orders/review/',

  // activities
  'api:activities': '/api/v1/activities/activities/',
  'api:activities:object': '/api/v1/activities/activities/:activityId/',
  'api:activities:object:respond':
    '/api/v1/activities/activities/:activityId/respond/',

  'api:demo-activities:object':
    '/api/v1/activities/demo-activities/:activityId/',
  'api:activities:activity-response-update-collaborators':
    '/api/v1/activities/activity_responses/:activityResponseId/',
  'api:activities:upload-activity-block-response-file':
    '/api/v1/activities/activity_responses/:activityResponseId/block/:blockId/upload-file/',
  'api:activities:generate-url-for-uploaded-file':
    '/api/v1/activities/activity_responses/:activityResponseId/block/:blockId/file-url/',

  'api:activities:upload-user-drawing-asset':
    '/api/v1/activities/upload-user-drawing-asset/', // TODO: Not limit to activities?

  'api:activities:class-activity-responses':
    '/api/v1/classes/:classId/activities/:activityId/responses/',

  'api:activities:responses-collaborated':
    '/api/v1/activities/:activityId/activity_responses/collaborated/',

  // success measures
  'api:record-success-measure-response':
    '/api/v1/record-success-measure-response/',
  'api:lesson-success-measure-responses':
    '/api/v1/lessons/:lessonId/success_measure_responses/',

  // student note(s)
  'api:student-notes': '/api/v1/classes/:classId/notes/:profileId/',
  'api:student-chunk-note': '/api/v1/student-notes/chunk/:chunkId/',

  // courses
  'api:my-courses': '/api/v1/my-courses/',

  // teacher dashboard lesson insights
  'api:questions-lesson-insights':
    '/api/v1/insights/questions/class/:classId/lesson/:lessonId/',
  'api:students-lesson-insights':
    '/api/v1/insights/students/class/:classId/lesson/:lessonId/',

  // teacher dashboard EM (exam) insights
  'api:em-insights': '/api/v1/insights/class/:classId/exam/:examId/',

  // Async result view
  'api:async_result_view': '/api/v1/async/result/',

  // Task Setting endpoints for teachers
  // GET | POST
  'api:tasks': '/api/v1/tasks/',
  // GET | PATCH | DELETE
  'api:tasks-detail': '/api/v1/tasks/:taskId/',
  // POST
  'api:tasks-duplicate': '/api/v1/tasks/:taskId/duplicate/',
  // POST
  'api:tasks-perform-task-action': '/api/v1/tasks/:taskId/action/',

  // Task Setting endpoints for students
  // GET
  'api:student_tasks-list': '/api/v1/student-tasks/',
  'api:student_tasks-detail': '/api/v1/student-tasks/:taskId/',
  'api:student_tasks-item-responses':
    '/api/v1/student-tasks/:taskId/item-responses/',

  // POST
  'api:student_tasks-start': '/api/v1/student-tasks/:taskId/start/',
  'api:student_tasks-submit': '/api/v1/student-tasks/:taskId/submit/',
  'api:student_tasks-perform-task-action':
    '/api/v1/student-tasks/:taskId/action/',

  'api:content_items-list': '/api/v1/content-items/',

  'api:branch': '/api/v1/branch/:courseId/',

  // GET fetch topics and question sets for a course
  'api:topic-question-sets-for-course':
    '/api/v1/topic-question-sets-for-course/:courseId/',

  // teacher dashboard task insights
  'api:task-insights': '/api/v1/insights/task/:taskId/',
  'api:task-responses': '/api/v1/tasks/task-items/:taskItemId/responses/',

  'api:spaced-retrieval-classes': '/api/v1/spaced-retrieval/classes/',
  'api:spaced-retrieval-configurations-create':
    '/api/v1/spaced-retrieval/configurations/',
  'api:spaced-retrieval-configurations-update':
    '/api/v1/spaced-retrieval/configurations/:id/',
};
